import Lottie, { Options } from 'react-lottie';
import { ErrorAnimation } from 'assets/lotties';
import { Box, Typography } from '@mui/material';

const defaultLottieOptions: Options = {
  loop: true,
  autoplay: true,
  animationData: ErrorAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const AnimatedError: React.FC = ({ children }) => (
  <Box sx={{ width: '100%', textAlign: 'center' }}>
    <Typography variant="h5">{children}</Typography>
    <Lottie options={defaultLottieOptions} style={{ maxWidth: 500 }} />
  </Box>
);

export default AnimatedError;
